import React from "react";
import { useTranslation } from "react-i18next";
import Modal from "components/Modal";
import Button from "components/Button";
import { IconClose } from "icons";

interface ContactAccountManagerModalProps {
  onClose: () => void;
  // P7 F2-F1: Plan & Billing opens it for a Refabric-managed contract with plan wording. Default: the seat-change text.
  description?: string;
}

// REF-5549 (BE REF-5446): enterprise/custom plans can't self-serve seat changes. The BE returns
// an action item with `action: "contact_account_manager"`; the shared payment-action handler
// surfaces this modal via the global WarningSnackbar so every caller (pricing, ChoosePlan, the
// admin seat-change modal) gets it. No form — these customers already have a dedicated AM.
const ContactAccountManagerModal: React.FC<ContactAccountManagerModalProps> = ({ onClose, description }) => {
  const { t } = useTranslation();

  return (
    <Modal onClose={onClose} show={true} bodyClassName="!border !border-grey-light bg-trueWhite dark:bg-surface-dark !max-w-[480px] !w-full p-5" className="!z-[99999]" backdropDisabled={true}>
      <div className="relative flex flex-col items-center gap-6 w-full">
        <div className="cursor-pointer absolute top-0 right-0 w-fit bg-grey-light rounded-full p-0.5" onClick={onClose}>
          <IconClose />
        </div>

        <div className="flex flex-col items-center gap-2.5 mt-4">
          <h3 className="text-h3 text-center dark:text-white">{t("billing:contact_account_manager.title")}</h3>
          <span className="text-bodyMd text-center text-grey">{description ?? t("billing:contact_account_manager.description")}</span>
        </div>

        <Button className="btn-primary w-full" onClick={onClose}>
          {t("billing:contact_account_manager.cta")}
        </Button>
      </div>
    </Modal>
  );
};

export default ContactAccountManagerModal;
